/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// CTA : SOCIAL STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library))
export default theme => ({
	social: {
		'& .message': {
			fontWeight: '600',
			marginBottom: pxToEm(15)
		},
		'& .link': {
			borderRadius: '100%',
			display: 'inline-flex',
			justifyContent: 'center',
			alignItems: 'center',
			alignContent: 'center',
			width: pxToEm(50),
			height: pxToEm(50),
			marginRight: pxToEm(16),
			'&:last-child': {
				marginRight: '0'
			},
			'& .icon': {
				color: theme.color.light.light.swatch,
				fontSize: pxToEm(22)
			},

			// types
			'&.name-facebook': { background: `#3B5999` },
			'&.name-twitter': { background: `#55ACEE` },
			'&.name-linkedin': { background: `#0077B5` }
		}
	}
});